<template>
  <VideosTab
    :product="slug"
    :categories-videos="categoriesVideos"
    @toggle-view-more="toggleViewMore"
    @play-video="$emit('play-video', $event)"
  />
</template>

<script lang="ts" setup>
import VideosTab from '~/components/market-insights/VideosTab.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  State
-------------------------------------*/
const isViewMoreActive = useState<boolean>('isViewMoreActive', () => false)

/*-------------------------------------
  Methods
-------------------------------------*/
const toggleViewMore = (isActive: boolean) => {
  isViewMoreActive.value = isActive
}

/*-------------------------------------
  Lifecycle
-------------------------------------*/
onUnmounted(() => {
  isViewMoreActive.value = false
})

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  slug: string
  categoriesVideos: string[] | null
}>()

defineEmits<{
  'play-video': [value: string]
}>()
</script>
